var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16656 3.71319C7.72505 2.62917 9.27495 2.62917 9.83344 3.71319L9.87026 3.78468C10.2059 4.43605 10.9629 4.74964 11.6608 4.52635L11.7374 4.50184C12.8988 4.13023 13.9948 5.22618 13.6232 6.3876L13.5987 6.46419C13.3754 7.16208 13.689 7.91915 14.3403 8.25474L14.4118 8.29156C15.4958 8.85005 15.4958 10.3999 14.4118 10.9584L14.3403 10.9953C13.689 11.3309 13.3754 12.0879 13.5987 12.7858L13.6232 12.8624C13.9948 14.0238 12.8988 15.1198 11.7374 14.7482L11.6608 14.7237C10.9629 14.5004 10.2059 14.814 9.87026 15.4653L9.83344 15.5368C9.27495 16.6208 7.72505 16.6208 7.16656 15.5368L7.12974 15.4653C6.79415 14.814 6.03708 14.5004 5.33919 14.7237L5.2626 14.7482C4.10118 15.1198 3.00523 14.0238 3.37684 12.8624L3.40135 12.7858C3.62464 12.0879 3.31105 11.3309 2.65968 10.9953L2.58819 10.9584C1.50417 10.3999 1.50417 8.85005 2.58819 8.29156L2.65968 8.25474C3.31105 7.91915 3.62464 7.16208 3.40135 6.46419L3.37684 6.3876C3.00523 5.22618 4.10118 4.13023 5.2626 4.50184L5.33919 4.52635C6.03708 4.74964 6.79415 4.43605 7.12974 3.78468L7.16656 3.71319Z",
    stroke: "#9296AC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.49678,
    cy: 9.624,
    rx: 3.4001,
    ry: 3.4,
    stroke: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigGray);
export default __webpack_public_path__ + "static/media/configGray.5c2018a2bb58b8fc2ff5c4687c59cfb9.svg";
export { ForwardRef as ReactComponent };